<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3166_81048)">
<mask id="path-1-inside-1_3166_81048" fill="white">
<rect x="1.095" y="6" width="19.81" height="10" rx="1"/>
</mask>
<rect x="1.095" y="6" width="19.81" height="10" rx="1" stroke="currentColor" stroke-width="3.4" mask="url(#path-1-inside-1_3166_81048)"/>
</g>
<defs>
<clipPath id="clip0_3166_81048">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
